module.exports = __webpack_public_path__ + "static/media/pias large.d6f4bd95.jpg";